/* src/app/defer-billing/defer-billing-presenter/defer-billing-presenter.component.scss */
body#themeTag :host ::ng-deep .cdk-virtual-scroll-viewport.p-datatable-virtual-scrollable-body.cdk-virtual-scroll-orientation-vertical.ng-star-inserted {
  overflow-y: hidden;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-bottom: 0;
}
.main-cell {
  width: 240px !important;
}
.data-cell {
  width: 128px !important;
}
/*# sourceMappingURL=defer-billing-presenter.component.css.map */
